import { values } from '@fortem-monorepo/js-utilities';
export const SIDE = {
    Long: 'Long',
    Short: 'Short',
};
export const SIDES = values(SIDE);
